import React from 'react';
import { Link } from 'react-router-dom';

// SLE logo, genuinely transparent.
//  - default ('color') : full-colour mark + wordmark (light surfaces, admin, etc.)
//  - 'nav'             : colour mark + WHITE wordmark, for the dark navbar & footer.
const SRC = {
  color: '/media/sle-logo-trim.png',
  nav: '/media/sle-logo-nav.png',
};

export const BrandLogo = ({ className = '', height = 40, to = '/', variant = 'color' }) => (
  <Link
    to={to}
    aria-label='Sri Lakshmi Enterprises — Home'
    className={`inline-flex items-center ${className}`}
    data-testid='brand-logo'
  >
    <img
      src={SRC[variant] || SRC.color}
      alt='Sri Lakshmi Enterprises'
      style={{ height, width: 'auto' }}
      className='block select-none'
      draggable={false}
    />
  </Link>
);
